/**
 * OTK print/report action label by canonical error_records.type.
 * Returns a locale key, never a hardcoded display string.
 *
 * Canonical API values (ErrorRecord.type):
 *   Interná chyba | Externá chyba | Reklamácia
 *
 * Mapping:
 *   Externá chyba → Reklamacia (complaint)
 *   Interná chyba → 8D report nadpis
 *   Reklamácia    → 8D report nadpis
 *
 * Fallback for null/unknown: 8D report nadpis — the print action is still EightDreport.
 */

export const OTK_ERROR_RECORD_TYPES = Object.freeze({
  INTERNAL: 'Interná chyba',
  EXTERNAL: 'Externá chyba',
  COMPLAINT: 'Reklamácia',
});

export const OTK_REPORT_LABEL_KEYS = Object.freeze({
  EIGHT_D: '8D report nadpis',
  COMPLAINT: 'Reklamacia',
});

export function normalizeOtkErrorRecordType(type) {
  if (type == null) return '';
  return String(type).trim();
}

export function otkReportActionLabelKey(type) {
  const canonical = normalizeOtkErrorRecordType(type);
  if (canonical === OTK_ERROR_RECORD_TYPES.EXTERNAL) {
    return OTK_REPORT_LABEL_KEYS.COMPLAINT;
  }
  return OTK_REPORT_LABEL_KEYS.EIGHT_D;
}
